import { useAtom } from 'jotai';
import { useQuery } from 'react-query';

import { getAvailableDatesTDA, getFullInitTDA } from '@/services/tda';
import { tdaDataAtom } from '@/store/tda';
import { ReponseFechasDisponiblesTDA } from '@/types/tda';

const COMMON_PARAMS = {
  refetchOnWindowFocus: false,
  keepPreviousData: false,
};
export const useGetFullInitData = () => {
  return useQuery(
    'getFullInitTDA',
    async () => await getFullInitTDA(),
    COMMON_PARAMS
  );
};

export const useTdaData = () => {
  const [tdaData, setTdaData] = useAtom(tdaDataAtom);

  const { isSuccess } = useQuery(
    'getAvailableDatesTDA',
    async () => await getAvailableDatesTDA(),
    {
      ...COMMON_PARAMS,
      onSuccess: (fetchedData: ReponseFechasDisponiblesTDA) => {
        setTdaData({ fechasDisponibles: fetchedData.fechas });
      },
    }
  );

  return {
    tdaData,
    isSuccess,
  };
};
